<template>
    <div id="transactionCompletePage">
        <div class="d-flex flex-column rounded align-items-center text-center py-4 px-lg-5 px-3 bg-white">
            <div class="lazada-hc-logo"></div>
            <div class="d-flex flex-column align-items-center text-center p-2">
                <img alt="" src="/img/lazada/no-app-icon.svg" class="img-responsive">
                <span class="font-md font-weight-bold my-3">Thank you for your interest <br />in Home Credit!</span>
                <span class="font-sm text-secondary">
                    You don't have the Home Credit app yet, but once you do, you can enjoy our exciting deals and offers, including topping up your Lazada Wallet.
                </span>
            </div>
        </div>
        <div class="d-flex flex-column rounded align-items-center text-center py-4 px-lg-5 px-3 mt-2 bg-white">
            <span class="font-md font-weight-bold mb-3">Download it now!</span>
            <span class="font-sm text-secondary margin-b24">
                You need the Home Credit app to proceed. Scan the QR code below to download.
            </span>
            <!-- <lazada-download class="cancel-margin-bottom" /> -->
            <download-opg-v3 class="px-4" google-play-id="loginGooglePlayBtn" qr-code-id="loginQRCode"></download-opg-v3>
            
            <span class="font-sm text-secondary mb-5 download-margin-bottom">
                Manage payments, avail of loans, shop in installments, receive promos and many more with Home Credit app!
                <br />
                <br />
                To learn more about HCPay, visit our website
            </span>
            <lazada-return :eventName="'err_no_hc_click_back_to_lazada'">Back to Lazada</lazada-return>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import embed_video from '../../components/embed_video.vue';
export default {
  components: { embed_video },
    created() {
        let g4Params = {
            'userId': this.$root.$data.account.userId,
            'cuid': this.$root.$data.account.cuid,
            'ip': this.$root.transaction.ipAddress,
            'user_agent': this.$root.$data.analyticsData.userAgent,
            'phone': this.$root.$data.analyticsData.phone,
            'operating_system': this.$root.$data.analyticsData.operatingSystem.name+"V"+this.$root.$data.analyticsData.operatingSystem.version,
            'browser': this.$root.$data.analyticsData.browser.name+"V"+this.$root.$data.analyticsData.browser.version,
            'transaction_type': 'WT',
        }       
        this.$root.triggerG4Event('err_no_hc_acct',g4Params)
    },
    
}
</script>
<style scoped>
    .transactionCompleteIcon {
        height: auto;
        width: 7rem;
    }
    .lazada-hc-logo {
        /* Layout Properties */
        top: 14px;
        left: 36px;
        width: 100%;
        height: 52px;
        margin-bottom: 41px;
        /* UI Properties */
        background: transparent url('/img/lazada/logos_desktop.png') center no-repeat padding-box;
        opacity: 1;
    }
    .cancel-margin-bottom {
        margin-bottom: 45px;
    }
    .margin-b24 {
        margin-bottom: 24px;
    }
    .download-margin-bottom {
        margin-bottom: 32px;
    }
</style>